/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetAnnouncementsResponseDataFromJSON, GetAnnouncementsResponseDataToJSON } from './GetAnnouncementsResponseData';
export function GetAnnouncementsResponseFromJSON(json) {
    return GetAnnouncementsResponseFromJSONTyped(json, false);
}
export function GetAnnouncementsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetAnnouncementsResponseDataFromJSON(json['data'])
    };
}
export function GetAnnouncementsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetAnnouncementsResponseDataToJSON(value.data)
    };
}
